<template>
  <div v-if="bannerList.length > 0" class="home-platform-page index-page">
    <!-- 首页顶部下载 APP 条已关闭
    <div data-v-ab7e7df3="" data-v-1ed58d81="" class="app-download-bar-v2" v-if="appshow">
      <div data-v-ab7e7df3="" class="flex-center">
        <span data-v-ab7e7df3="" class="close-btn" @click="appshow = false">×</span>
        <div data-v-ab7e7df3="" class="icon">
          <img data-v-ab7e7df3="" src="https://9pgh5.liwifi.top/assets/9pg-DYmuSJSM.png" alt="icon" class="fit-image">
        </div>
        <div data-v-ab7e7df3="" class="medium-text text">{{ $t('Official Domain') }}<span data-v-ab7e7df3="" class="text-domain-name">9PG.app</span>{{ $t('Please Install APP') }}</div>
      </div>
      <div data-v-ab7e7df3="" class="download-btn" @click="$parent.goNav('/app')">{{ $t('Download Now') }}&gt;</div>
    </div>
    -->
    
    <div style="position: relative"></div>

    <div v-if="showRealnamePrompt" class="realname-prompt-mask" @click.self="dismissRealnamePrompt">
      <div class="realname-prompt-card" @click.stop>
        <button type="button" class="realname-prompt-close" aria-label="关闭" @click="dismissRealnamePrompt">×</button>
        <div class="reward-card-orb reward-card-orb-top"></div>
        <div class="reward-card-orb reward-card-orb-bottom"></div>
        <div class="reward-card-header">
          <div class="reward-card-icon">🎁</div>
          <div>
            <div class="reward-card-eyebrow">新用户专享</div>
            <div class="reward-card-label">彩金福利</div>
          </div>
        </div>
        <div class="realname-prompt-title">完成实名认证<br /><strong>即可领取新用户彩金福利</strong></div>
        <div class="realname-prompt-text">
          完善资料并完成邮箱验证，认证完成即可领取，不错过专属福利。
        </div>
        <div class="reward-card-benefits">
          <div class="reward-card-benefit"><span class="reward-card-check">✓</span><span>完成认证即可领取</span></div>
          <div class="reward-card-benefit"><span class="reward-card-check">✓</span><span>解锁提现账号绑定</span></div>
        </div>
        <div v-if="realnameMissingFields.length" class="reward-card-missing">
          待完成：{{ realnameMissingFields.join('、') }}
        </div>
        <div class="realname-prompt-actions">
          <button type="button" class="realname-prompt-later" @click="dismissRealnamePrompt">稍后再说</button>
          <button type="button" class="realname-prompt-go" @click="goRealnameAuth">立即完成认证</button>
        </div>
      </div>
    </div>

    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />
        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}
          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">{{ $t('More Announcements') }}</van-button>
        </div>
      </div>
    </div>

    <div class="xiding" :style="{ top: appshow ? '1rem' : '0' }">
      <div class="banner-wrapper" v-if="localBanners.length > 0">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
          <van-swipe-item v-for="(item, index) in localBanners" :key="index">
            <img
              :src="item.src || item"
              class="banner-img"
              @click="onBannerClick(item)"
            />
          </van-swipe-item>
          <template #indicator>
            <div class="swiper-dots">
              <div class="num">{{ current + 1 }}</div>
              <div class="sign">/</div>
              <div class="num">{{ localBanners.length }}</div>
            </div>
          </template>
        </van-swipe>
      </div>

      <div class="caosuo">
        <div class="lefsg home-user-entry" v-if="$store.state.token" @click="$parent.goNav('/mine')">
          <div class="home-user-summary">
            <img
              :src="$store.state.userInfo.avatar || '/static/image/imageAvatar02@3x.png'"
              alt="avatar"
              class="home-user-avatar"
            />
            <div class="home-user-details">
              <div class="home-user-name-row">
                <span class="home-user-name">{{ $store.state.userInfo.username || $store.state.userInfo.userid || $store.state.userInfo.id || $store.state.userInfo.user_id || $store.state.userInfo.account || $store.state.userInfo.name || $store.state.userInfo.nickname || '会员' }}</span>
              </div>
              <div class="home-user-balance">
                <span class="home-user-currency">￥</span>
                <strong>{{ $store.getters.safeBalance }}</strong>
                <button type="button" class="home-balance-refresh" aria-label="刷新余额" @click.stop="refreshBalance">
                  <img :class="{ 'rotate': isRefreshing }" src="/static/style/sx.png" alt="reload" class="fit-image" />
                </button>
              </div>
            </div>
            <span class="home-user-arrow" aria-hidden="true">›</span>
          </div>
        </div>
        
        <!-- 更新后的登录注册按钮区域 -->
        <div v-else class="balance-wrapper">
          <div class="login-wrapper">
            <div class="regist-button button custom-reg-btn medium" @click="showRegister = true">
              {{ $t('Register') }}
            </div>
            <div id="login-button" class="button custom-login-btn medium" @click="showLogin = true">
              {{ $t('Login') }}
            </div>
          </div>
        </div>
       
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <div class="img-wrapper">
              <img src="/static/style/feature_moneydraw.cbeb513bc9fd00ecc5372fc0e54a84c0.png" alt="" />
              <!-- <div class="right-top-label">送3%</div> -->
            </div>
            <div class="icon-text">{{ $t('Deposit') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/feature_moneysave.4b60fbaf4ee368d1e7060133f62690c9.png" alt="" />
            <div class="icon-text">{{ $t('Withdraw') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/agentPartnership')">
            <div class="img-wrapper">
              <img src="/static/style/icon-entry-user.23a66636e493d09cead559304aaf0466.png" alt="代理合营" />
            </div>
            <div class="icon-text">代理合营</div>
          </div>
          <div class="lisImg" @click="$parent.openKefu">
            <img src="/static/style/kffff.png" alt="" />
            <div class="icon-text">{{ $t('Customer Service') }}</div>
          </div>
        </div>
      </div>

      <div class="top-tab-bar" v-if="gameType === 2 || gameType === 3 || gameType === 4 || gameType === 5">
        <div class="game-type-tabs">
          <template v-if="gameType === 2">
            <div class="game-type-tab" :class="{ 'active': !selectedFishingPlatform }" @click="selectFishingPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedFishingPlatform === 'BGBY' }" @click="selectFishingPlatform('BGBY')">BG</div>
            <div class="game-type-tab" :class="{ 'active': selectedFishingPlatform === 'AG' }" @click="selectFishingPlatform('AG')">PA</div>
          </template>
          <template v-if="gameType === 3">
            <div class="game-type-tab" :class="{ 'active': !selectedJokerPlatform }" @click="selectJokerPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'BBQP' }" @click="selectJokerPlatform('BBQP')">BBIN</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'BGQP' }" @click="selectJokerPlatform('BGQP')">BG</div>
            <div class="game-type-tab" :class="{ 'active': selectedJokerPlatform === 'AG' }" @click="selectJokerPlatform('AG')">AG</div>
          </template>
          <template v-if="gameType === 4">
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'PG' }" @click="selectPlatform('PG')">PG</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'PP' }" @click="selectPlatform('PP')">PP</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'CQ9' }" @click="selectPlatform('CQ9')">CQ9</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'JDB' }" @click="selectPlatform('JDB')">JDB</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'JILI' }" @click="selectPlatform('JILI')">JILI</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'FC' }" @click="selectPlatform('FC')">FC</div>
            <div class="game-type-tab" :class="{ 'active': selectedPlatform === 'WG' }" @click="selectPlatform('WG')">WG</div>
          </template>
          <template v-if="gameType === 5">
            <div class="game-type-tab" :class="{ 'active': !selectedLotteryPlatform }" @click="selectLotteryPlatform('')">{{ $t('All') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'LHC' }" @click="selectLotteryPlatform('LHC')">{{ $t('Mark Six') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'JSC' }" @click="selectLotteryPlatform('JSC')">{{ $t('Speed Lottery') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'JWC' }" @click="selectLotteryPlatform('JWC')">{{ $t('Overseas Lottery') }}</div>
            <div class="game-type-tab" :class="{ 'active': selectedLotteryPlatform === 'QKC' }" @click="selectLotteryPlatform('QKC')">{{ $t('Blockchain Lottery') }}</div>
          </template>
        </div>
        <div class="search-icon" @click="toggleSearchBox" v-if="gameType === 4">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img">
        </div>
        <div class="search-box" v-if="showSearchBox && gameType === 4">
          <div class="search-input-wrapper">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img-inside">
            <input type="text" v-model="searchKeyword" @input="searchGames" :placeholder="$t('Search Games')" class="search-input-with-icon">
          </div>
          <div class="search-close" @click="closeSearchBox">×</div>
        </div>
      </div>
    </div>

    <div class="gameBoxs" :style="{ marginTop: (6.0 + (appshow ? 1 : 0) + ([2, 3, 4, 5].includes(gameType) ? 1.1 : 0)) + 'rem' }">
      <div class="lfst" :style="{ top: (6.0 + (appshow ? 1 : 0) + ([2, 3, 4, 5].includes(gameType) ? 1.1 : 0)) + 'rem' }">
        <div :class="gameType == 6 ? 'ls active' : 'ls'" @click="changGameType(6)">
          <img src="/static/style/sidebar_hot.svg" alt="" />
          <span>{{ $t('Hot') }}</span>
        </div>
        <div :class="gameType == 4 ? 'ls active' : 'ls'" @click="changGameType(4)">
          <img src="/static/style/sidebar_slots.svg" alt="" />
          <span>{{ $t('Slots') }}</span>
        </div>
        <div :class="gameType == 0 ? 'ls active' : 'ls'" @click="changGameType(0)">
          <img src="/static/style/sidebar_livecasino.svg" alt="" />
          <span>{{ $t('Live Casino') }}</span>
        </div>
        <div :class="gameType == 1 ? 'ls active' : 'ls'" @click="changGameType(1)">
          <img src="/static/style/sidebar_sports.svg" alt="" />
          <span>{{ $t('Sports') }}</span>
        </div>
        <div :class="gameType == 2 ? 'ls active' : 'ls'" @click="changGameType(2)">
          <img src="/static/style/sidebar_fishing.svg" alt="" />
          <span>{{ $t('Fishing') }}</span>
        </div>
        <div :class="gameType == 3 ? 'ls active' : 'ls'" @click="changGameType(3)">
          <img src="/static/style/sidebar_board.svg" alt="" />
          <span>{{ $t('Board Games') }}</span>
        </div>
        <div :class="gameType == 5 ? 'ls active' : 'ls'" @click="changGameType(5)">
          <img src="/static/style/sidebar_lottery.svg" alt="" />
          <span>{{ $t('Lottery') }}</span>
        </div>
      </div>

      <div class="content-area">
        <div class="rigts hot-grid" v-if="gameType == 6">
          <div class="game-item" v-for="(item, index) in $store.state.fishingList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'fishing')" alt="" />
              <div class="api-icon" v-if="getImageUrl(item.api_logo_img)">
                <img :src="getImageUrl(item.api_logo_img)" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts single-column realbet-content" v-if="gameType == 0">
          <div class="realbet-game-item" v-for="(item, index) in $store.state.realbetList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="realbet-icon-container">
              <img :src="getGameImg(item, 'realbet')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts single-column sport-content" v-if="gameType == 1">
          <div class="sport-game-item" v-for="(item, index) in $store.state.sportList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="sport-icon-container">
              <img :src="getGameImg(item, 'sport')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 2">
          <div class="game-item" v-for="(item, index) in filteredFishingGames.length > 0 ? filteredFishingGames : $store.state.gamingList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'gaming')" alt="" />
              <div class="api-icon" v-if="getImageUrl(item.api_logo_img)">
                <img :src="getImageUrl(item.api_logo_img)" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 3">
          <div class="game-item" v-for="(item, index) in filteredJokerGames.length > 0 ? filteredJokerGames : $store.state.jokerList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'joker')" alt="" />
              <div class="api-icon" v-if="getImageUrl(item.api_logo_img)">
                <img :src="getImageUrl(item.api_logo_img)" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 4">
          <div class="game-item" v-for="(item, index) in filteredGames.length > 0 ? filteredGames : $store.state.conciseList" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'concise')" alt="" />
              <div class="api-icon" v-if="getImageUrl(item.api_logo_img)">
                <img :src="getImageUrl(item.api_logo_img)" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 5">
          <div class="game-item" v-for="(item, index) in filteredLotteryGames" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)" :class="{ 'full-width': item.platform_name == 'vrbet' }">
            <div class="game-icon-container">
              <img :style="item.platform_name == 'vrbet' ? 'width:100%' : ''" :src="getGameImg(item, 'lottery')" alt="" />
              <div class="api-icon" v-if="getImageUrl(item.api_logo_img)">
                <img :src="getImageUrl(item.api_logo_img)" alt="API Icon" />
              </div>
            </div>
            <div class="game-name">{{ $t(item.name || item.game_name || item.title || 'Game') }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>{{ $t('Welcome to') }}{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">{{ $t('Exclusive VIP Experience') }}</div>
            <p>{{ $t('Enjoy member privileges') }}</p>
            <p>{{ $t('Enjoy uniqueness that belongs only to you') }}</p>
            <dd @click="$parent.goNav('/vip')">{{ $t('Member Center') }}</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />{{ $t('Message Center') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />{{ $t('Feedback') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />{{ $t('Permanent Domain') }}<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />{{ $t('About Us') }}<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">{{ $t('Login Now') }}</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />{{ $t('Safe Logout') }}</div>
        </div>
      </div>
    </van-popup>

    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
    
    <div class="login-modal-wrapper" v-if="showLogin">
      <div class="login-modal-overlay" @click="showLogin = false"></div>
      <div class="login-modal-content">
        <login
          :key="'login-' + loginKey"
          :invite-pid="invitePid"
          :prefill-username="prefillUsername"
          @close="showLogin = false"
          @registered="handleRegistered"
        ></login>
      </div>
    </div>
    <div class="login-modal-wrapper" v-if="showRegister">
      <div class="login-modal-overlay" @click="showRegister = false"></div>
      <div class="login-modal-content">
        <login
          :key="'register-' + loginKey"
          :invite-pid="invitePid"
          :initial-type="1"
          @close="showRegister = false"
          @registered="handleRegistered"
        ></login>
      </div>
    </div>

  </div>
</template>

<script>
import login from '../login.vue';

export default {
  name: 'index',
  components: {
    login,
  },
  data() {
    return {
      localBanners: [],
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [1], 
      homenoticelis: [],
      leftshow: false,
      activeKey: 0,
      gameType: 6,
      tanshow: true,
      appshow: false,
      goInfo: null,
      showLogin: false,
      showRegister: false,
      prefillUsername: '',
      loginKey: 0,
      isRefreshing: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      initialLeft: 0,
      initialTop: 0,
      showSearchBox: false,
      searchKeyword: '',
      filteredGames: [],
      selectedPlatform: '',
      selectedFishingPlatform: '',
      filteredFishingGames: [],
      selectedJokerPlatform: '',
      filteredJokerGames: [],
      selectedLotteryPlatform: '',
      filteredLotteryGames: [],
      
      showRealnamePrompt: false,
      realnamePromptLoading: false,
      realnamePromptEntryId: '',
      realnamePromptLastHandledId: '',
      realnameMissingFields: [],
    };
  },
  computed: {
    invitePid() {
      return this.$route.query.pid || sessionStorage.getItem('invitePid') || '';
    },
    isLoggedIn() {
      return !!(this.$store.state.token || sessionStorage.getItem('token'));
    }
  },
  watch: {
    isLoggedIn(value) {
      if (value) {
        if (this.$route.path === '/') {
          this.checkRealnameStatus();
        }
      } else {
        this.showRealnamePrompt = false;
        this.realnameMissingFields = [];
        this.realnamePromptEntryId = '';
        this.realnamePromptLastHandledId = '';
        this.realnamePromptLoading = false;
      }
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice();
    that.checkRealnameStatus();
    if (that.$route.query.pid) {
      sessionStorage.setItem('invitePid', that.$route.query.pid);
    }
  },
  methods: {
    createHomePromptRequestId(source) {
      return `${source || 'home'}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    },
    checkRealnameStatus(requestId) {
      if (this.$route.path !== '/') {
        return;
      }
      if (!this.isLoggedIn) {
        this.showRealnamePrompt = false;
        this.realnameMissingFields = [];
        return;
      }
      if (this.realnamePromptLoading) {
        return;
      }

      const activeRequestId = requestId || this.createHomePromptRequestId('home');
      if (this.realnamePromptLastHandledId === activeRequestId) {
        return;
      }
      this.realnamePromptEntryId = activeRequestId;
      this.realnamePromptLoading = true;
      this.$apiFun.post('/api/realname-status', {}).then(res => {
        if (this.realnamePromptEntryId !== activeRequestId) {
          return;
        }
        if (res.code !== 200) {
          this.showRealnamePrompt = false;
          this.realnameMissingFields = [];
          return;
        }
        const data = res.data || {};
        const missingFields = [];

        // 首页弹窗：姓名 + 邮箱验证即可关闭，不再要求生日/审核通过。
        const profileReady = data.profile_ready === true
          || (data.email_verified === true && data.realname_info_complete === true);
        const completed = profileReady
          || data.completed === true
          || data.verified === true
          || data.completion_status === 'completed';
        if (!completed) {
          if (data.completion_status === 'email_verification_required' || data.email_verified === false) {
            missingFields.push('邮箱验证');
          }
          if (data.completion_status === 'realname_info_required' || data.realname_info_complete === false) {
            missingFields.push('真实姓名');
          }
          if (!missingFields.length) {
            if (data.completion_text) {
              missingFields.push(data.completion_text);
            } else {
              missingFields.push('请先完成实名认证');
            }
          }
        }

        this.realnameMissingFields = Array.from(new Set(missingFields));
        this.showRealnamePrompt = !completed && this.realnameMissingFields.length > 0;
        if (completed || this.showRealnamePrompt) {
          this.realnamePromptLastHandledId = activeRequestId;
        }
      }).catch(err => {
        console.error('首页实名状态检查失败:', err);
      }).finally(() => {
        if (this.realnamePromptEntryId === activeRequestId) {
          this.realnamePromptLoading = false;
        }
      });
    },
    dismissRealnamePrompt() {
      this.showRealnamePrompt = false;
    },
    goRealnameAuth() {
      this.showRealnamePrompt = false;
      this.$router.push({ path: '/realnameAuth' });
    },
    handleRegistered(payload) {
      const username = (payload && payload.username) || sessionStorage.getItem('pendingLoginName') || '';
      this.prefillUsername = username;
      this.showRegister = false;
      this.showLogin = false;
      if (payload && payload.redirect) {
        this.$router.push({ path: payload.redirect });
        return;
      }
      this.loginKey += 1;
      this.$nextTick(() => {
        this.showLogin = true;
      });
    },
    openGogao(val) { this.goInfo = val; },
    changtanshow() { this.tanshow = !this.tanshow; },
    changGameType(type) {
      this.gameType = type;
      if (type === 4 && !this.selectedPlatform) {
        this.selectedPlatform = 'PG';
        this.filterGamesByPlatform();
      }
      if (type === 5) {
        this.selectedLotteryPlatform = '';
        this.filterLotteryGamesByPlatform();
      }
    },
    getGameImg(item) {
      const imgFields = [
        'mobile_img', 'app_img', 'img', 'image', 'icon', 'cover', 'photo',
        'appimg', 'appimage', 'game_img', 'game_icon', 'game_image',
        'img_url', 'image_url', 'icon_url', 'icon_img',
        'appIcon', 'appImage', 'gameIcon', 'gameImage', 'gameImg',
        'iconUrl', 'imgUrl', 'imageUrl',
        'logo', 'thumb', 'thumbnail', 'pic', 'picture'
      ];
      for (const field of imgFields) {
        const imageUrl = this.getImageUrl(item[field]);
        if (imageUrl) {
          return imageUrl;
        }
      }
      return '';
    },
    getImageUrl(src) {
      if (typeof src !== 'string') {
        return '';
      }
      const imageUrl = src.trim();
      if (!imageUrl || /^(data:|blob:|\/\/)/i.test(imageUrl)) {
        return imageUrl;
      }
      if (/^https?:\/\//i.test(imageUrl)) {
        return imageUrl;
      }

      // Some records wrap a remote image URL in an uploads path, with or
      // without a leading slash (for example: uploads/https://cdn/... ).
      const embeddedHttpMatch = imageUrl.match(/(?:^|\/)(https?:\/\/.*)$/i);
      if (embeddedHttpMatch) {
        return embeddedHttpMatch[1];
      }

      const baseURL = window.location.origin.replace(/\/+$/, '');
      return baseURL + '/' + imageUrl.replace(/^\/+/, '');
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, this.$t('Copy Successful')); 
    },
    changleftshow() { this.leftshow = !this.leftshow; },
    refreshBalance() {
      let that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      that.$apiFun.post('/api/balance', {}).then(res => {
        if (res.code == 200 && res.data && res.data.balance !== undefined) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).catch(err => {}).finally(() => {
        that.isRefreshing = false;
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/bannerList', { type: 2 }).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) {
          const list = Array.isArray(res.data) ? res.data : [];
          that.bannerList = list.length ? list : [1];
          that.localBanners = list
            .map(item => ({
              src: item.src || item.pic || '',
              url: item.url || item.jump_url || '',
              title: item.title || ''
            }))
            .filter(item => !!item.src);
          that.current = 0;
        }
        that.$parent.hideLoading();
      }).catch(() => { that.$parent.hideLoading(); });
    },
    onBannerClick(item) {
      const url = item && (item.url || item.jump_url);
      if (!url) return;
      if (/^https?:\/\//i.test(url)) {
        window.location.href = url;
        return;
      }
      if (this.$parent && typeof this.$parent.goNav === 'function') {
        this.$parent.goNav(url);
      }
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) { this.current = index; },
    changhongbashow() { this.hongbashow = false; },
    changappShow() { this.appShow = false; },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const rect = tabBar.getBoundingClientRect();
        this.initialLeft = rect.left;
        this.initialTop = rect.top;
      }
    },
    drag(event) {
      if (!this.isDragging) return;
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const parentRect = tabBar.parentElement.getBoundingClientRect();
        const tabRect = tabBar.getBoundingClientRect();
        let newLeft = this.initialLeft + deltaX;
        let newTop = this.initialTop + deltaY;
        newLeft = Math.max(0, Math.min(newLeft, parentRect.width - tabRect.width));
        newTop = Math.max(0, Math.min(newTop, parentRect.height - tabRect.height));
        tabBar.style.position = 'absolute';
        tabBar.style.left = newLeft - parentRect.left + 'px';
        tabBar.style.top = newTop - parentRect.top + 'px';
        tabBar.style.zIndex = '100';
      }
      event.preventDefault();
      event.stopPropagation();
    },
    stopDrag() { this.isDragging = false; },
    toggleSearchBox() {
      this.showSearchBox = !this.showSearchBox;
      if (this.showSearchBox) {
        this.searchKeyword = '';
        this.filteredGames = [];
      }
    },
    closeSearchBox() {
      this.showSearchBox = false;
      this.searchKeyword = '';
      this.filteredGames = [];
    },
    searchGames() {
      if (!this.searchKeyword.trim()) {
        this.filteredGames = [];
        return;
      }
      const keyword = this.searchKeyword.toLowerCase().trim();
      const games = this.$store.state.conciseList || [];
      this.filteredGames = games.filter(game => {
        const gameName = (game.name || '').toLowerCase();
        const platformName = (game.platform_name || '').toLowerCase();
        const gameCode = (game.game_code || '').toLowerCase();
        return gameName.includes(keyword) || platformName.includes(keyword) || gameCode.includes(keyword);
      });
    },
    selectPlatform(platform) {
      if (this.selectedPlatform === platform) {
        this.selectedPlatform = '';
        this.filteredGames = [];
      } else {
        this.selectedPlatform = platform;
        this.filterGamesByPlatform();
      }
    },
    filterGamesByPlatform() {
      if (!this.selectedPlatform) {
        this.filteredGames = [];
        return;
      }
      const platform = this.selectedPlatform.toLowerCase();
      const games = this.$store.state.conciseList || [];
      this.filteredGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectFishingPlatform(platform) {
      this.selectedFishingPlatform = platform;
      if (!platform) {
        this.filteredFishingGames = [];
      } else {
        this.filterFishingGamesByPlatform();
      }
    },
    filterFishingGamesByPlatform() {
      if (!this.selectedFishingPlatform) {
        this.filteredFishingGames = [];
        return;
      }
      const platform = this.selectedFishingPlatform.toLowerCase();
      const games = this.$store.state.gamingList || [];
      this.filteredFishingGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectJokerPlatform(platform) {
      this.selectedJokerPlatform = platform;
      if (!platform) {
        this.filteredJokerGames = [];
      } else {
        this.filterJokerGamesByPlatform();
      }
    },
    filterJokerGamesByPlatform() {
      if (!this.selectedJokerPlatform) {
        this.filteredJokerGames = [];
        return;
      }
      const platform = this.selectedJokerPlatform.toLowerCase();
      const games = this.$store.state.jokerList || [];
      this.filteredJokerGames = games.filter(game => {
        const platformName = (game.platform_name || '').toLowerCase();
        return platformName === platform;
      });
    },
    selectLotteryPlatform(platform) {
      this.selectedLotteryPlatform = platform;
      this.filterLotteryGamesByPlatform();
    },
    filterLotteryGamesByPlatform() {
      const category = this.selectedLotteryPlatform;
      let games = [];
      if (!category) {
        games = [
          ...(this.$store.state.lhcList || []),
          ...(this.$store.state.jscList || []),
          ...(this.$store.state.jwcList || []),
          ...(this.$store.state.qkcList || [])
        ];
      } else if (category === 'LHC') {
        games = this.$store.state.lhcList || [];
      } else if (category === 'JSC') {
        games = this.$store.state.jscList || [];
      } else if (category === 'JWC') {
        games = this.$store.state.jwcList || [];
      } else if (category === 'QKC') {
        games = this.$store.state.qkcList || [];
      } else {
        games = (this.$store.state.lotteryList || []).filter(game => {
          const platformName = (game.platform_name || '').toLowerCase();
          return platformName === category;
        });
      }
      this.filteredLotteryGames = games;
    },
  },
  mounted() {
    this._handleHomePromptRequest = (event) => {
      const requestId = event && event.detail && event.detail.requestId ? String(event.detail.requestId) : '';
      this.checkRealnameStatus(requestId);
    };
    window.addEventListener('cs-home-realname-prompt', this._handleHomePromptRequest);
  },
  activated() {
    this.checkRealnameStatus();
  },
  updated() {},
  beforeDestroy() {
    if (this._handleHomePromptRequest) {
      window.removeEventListener('cs-home-realname-prompt', this._handleHomePromptRequest);
      this._handleHomePromptRequest = null;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';

.domainModal_content__1nBgc {
  overflow: auto;
  background-color: #1a1a1a; 
  color: #ffffff; 
}

.realname-prompt-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.58);
  box-sizing: border-box;
}

.realname-prompt-card {
  position: relative;
  width: 100%;
  max-width: 360px;
  padding: 24px 20px 20px;
  overflow: hidden;
  border: 1px solid rgba(255, 221, 137, 0.38);
  border-radius: 22px;
  background: linear-gradient(145deg, #173d83 0%, #0b2358 55%, #07183f 100%);
  box-sizing: border-box;
  color: #fff;
  box-shadow: 0 20px 50px rgba(2, 13, 42, 0.48);
}

.realname-prompt-close {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 2;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.82);
  font-size: 22px;
  line-height: 28px;
}

.reward-card-orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.reward-card-orb-top {
  top: -112px;
  right: -68px;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(255, 219, 125, 0.34), rgba(255, 219, 125, 0));
}

.reward-card-orb-bottom {
  bottom: -138px;
  left: -92px;
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(83, 167, 255, 0.2), rgba(83, 167, 255, 0));
}

.reward-card-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.reward-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border: 1px solid rgba(255, 232, 167, 0.65);
  border-radius: 16px;
  background: linear-gradient(145deg, #ffe9a2, #f6b839);
  box-shadow: 0 8px 18px rgba(246, 184, 57, 0.28);
  font-size: 28px;
}

.reward-card-eyebrow {
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  letter-spacing: 0.08em;
}

.reward-card-label {
  margin-top: 2px;
  color: #ffe19a;
  font-size: 18px;
  font-weight: 700;
}

.realname-prompt-title {
  position: relative;
  z-index: 1;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.45;
  text-align: left;
}

.realname-prompt-title strong {
  color: #ffe09a;
  font-size: 22px;
}

.realname-prompt-text {
  position: relative;
  z-index: 1;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 14px;
  line-height: 1.6;
}

.reward-card-benefits {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 8px;
  margin-top: 16px;
  padding: 13px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.08);
}

.reward-card-benefit {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
}

.reward-card-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #f6c65c;
  color: #17325f;
  font-size: 12px;
  font-weight: 700;
}

.reward-card-missing {
  position: relative;
  z-index: 1;
  margin-top: 12px;
  color: #ffe09a;
  font-size: 12px;
}

.realname-prompt-actions {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.realname-prompt-actions button {
  flex: 1;
  height: 38px;
  border-radius: 19px;
  font-size: 14px;
  font-weight: 700;
}

.realname-prompt-later {
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.84);
}

.realname-prompt-go {
  border: 0;
  background: linear-gradient(135deg, #ffe59b, #f4b937);
  color: #193563;
  box-shadow: 0 7px 15px rgba(244, 185, 55, 0.24);
}

/* ---------------- 顶部 logo & 语言切换区域 ---------------- */
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 15px 4px 15px;
  background-color: #000000;
}

.logo-icon {
  height: 28px; 
  width: auto;
  max-width: 120px;
  object-fit: contain;
}

/* 新增：多语言按钮样式 */
.lang-switch-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.globe-icon {
  color: #fff;
}
.lang-text {
  color: #fff;
  font-size: 13px;
  font-weight: bold;
}

/* 新增：语言菜单底部弹窗样式 */
.lang-menu-content {
  background-color: #1a1a1a;
  color: #fff;
  text-align: center;
}
.lang-title {
  padding: 15px;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #333;
}
.lang-item {
  padding: 16px;
  font-size: 16px;
  border-bottom: 1px solid #333;
  transition: all 0.2s;
}
.lang-item:active {
  background-color: #333;
}
.lang-item.active {
  color: #1890ff; /* 选中的语言变蓝 */
  font-weight: bold;
}
.lang-cancel {
  padding: 16px;
  font-size: 16px;
  color: #999;
  margin-top: 6px;
  background-color: #222;
}
/* ---------------- 结束 ---------------- */

.banner-wrapper {
  padding: 0.1rem; 
  padding-top: 0.05rem; 
  background-color: transparent; 
  width: 100%;
  box-sizing: border-box;
}

.my-swipe {
  width: 100%;
  height: 3.8rem;
  border-radius: 8px; 
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.swiper-dots {
  display: flex;
  position: absolute;
  right: 15px; 
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6); 
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  
  .num {
    font-size: 12px;
    color: #fff;
    line-height: 24px;
    width: auto;
  }
  .sign {
    margin: 0 2px;
    font-size: 10px;
    color: rgba(255,255,255,0.7);
    line-height: 24px;
    position: static;
    transform: none;
  }
}

.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #121212; 
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
      color: #ffffff; 
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #333333; 
      color: #e0e0e0; 
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #333333; 
    border-radius: 0.4rem;
    border: 0;
    color: #ffffff; 
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}

.gonggao {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 97%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .meys {
      display: flex;
      align-items: center;
      margin-top: 10px; 
      .lefs {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff; 
        span {
          font-size: 18px;
          font-weight: 700;
        }
        .imsg {
          margin-left: 8px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            &.rotate {
              animation: rotate 1s linear infinite;
            }
          }
        }
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      }
    }
  }
  
  /* 重写右侧四个图标容器的 CSS 布局 */
  .riggs {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start; /* 顶部对齐，防止文本折行后图标错位 */
    flex-wrap: nowrap;
    padding: 0;
    gap: 3px;
    flex: 1; /* 占据右侧全部剩余空间 */

    .lisImg {
      flex: 1; /* 平均分配宽度 */
      max-width: 65px; /* 控制最大宽度，避免挤占左侧登录区域 */
      text-align: center;
      color: #ffffff; 
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .img-wrapper {
        position: relative;
        display: inline-block;
        width: 32px; /* 固定图标大小 */
        height: 32px;
        margin: 0 auto;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        
        .right-top-label {
          position: absolute;
          top: -2px;
          right: -12px;
          background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
          color: #fff;
          font-size: 10px;
          border-radius: 4px;
          white-space: nowrap;
          z-index: 10;
          transform: scale(0.8); /* 缩小送3%标签，防止撑爆 */
        }
      }
      
      > img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
      
      .link-icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      
      .icon-text {
        font-size: 11px; /* 缩小字号兼容英文 */
        line-height: 1.1;
        margin-top: 4px;
        width: 100%;
        text-align: center;
        word-wrap: break-word; /* 允许长单词换行 */
        white-space: normal; /* 允许折行 */
      }
    }
  }
}

.xiding {
  background-color: #000000; 
  position: fixed;
  left: 0;
  right: 0;
  z-index: 99;
  transition: top 0.3s ease;
}

.balance-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px; 
}


/* ----- 完美还原原来图片质感的多语言登录注册按钮 ----- */
.login-wrapper {
  display: flex;
  gap: 8px; /* 两个按钮的间距 */
  flex-shrink: 0;
  align-items: center;

  .button {
    height: 0.65rem;
    line-height: 0.65rem;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 0.32rem !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-width: 1.4rem; /* 保证英文单词不被挤扁 */
    white-space: nowrap; 
    text-align: center;
    transition: all 0.2s;
  }

  /* 还原原来的 "注册" 白色按钮外观 */
  .custom-reg-btn {
    background-color: #ffffff;
    color: #555555;
    border: 1px solid #dcdcdc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* 微微的立体阴影 */
  }
  .custom-reg-btn:active {
    background-color: #f5f5f5;
  }

  /* 还原原来的 "登录" 蓝色渐变按钮外观 */
  .custom-login-btn {
    background: linear-gradient(180deg, #60a5fa 0%, #1890ff 100%); /* 仿制原图的蓝底渐变 */
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(24, 144, 255, 0.3); /* 蓝色立体发光阴影 */
  }
  .custom-login-btn:active {
    background: linear-gradient(180deg, #3b82f6 0%, #096dd9 100%);
  }
}

.gameBoxs {
  background-color: #000000; 
  box-sizing: border-box;
  color: #e0e0e0; 
  height: 100%;
  min-height: 608px;
  display: flex;
  justify-content: space-between;

  /* 3. 仅针对左侧菜单的文字溢出做最小化修复 */
  .lfst {
    width: 1.25rem; /* 恢复原本的宽度，不挤压右侧 */
    box-sizing: border-box;
    padding: 0.06rem 0.04rem 0.08rem;
    border-radius: 18px;
    position: fixed;
    left: 0.05rem; /* 稍微往左靠一点点 (原来是 0.1rem) */
    bottom: 75px; 
    overflow-y: auto;
    z-index: 99;
    transition: top 0.3s ease;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    will-change: top;
    -webkit-will-change: top;
    background: rgba(255, 255, 255, 0.98) url(/static/style/bbbb.png) center/100% 100% no-repeat;
    border: 1px solid rgba(226, 234, 243, 0.95);
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
    overscroll-behavior: contain;
    scrollbar-width: none;
    -ms-overflow-style: none;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    .ls.active {
      color: #1677ff;
      background: linear-gradient(180deg, #f5faff 0%, #eaf4ff 100%);
      border-color: rgba(164, 205, 255, 0.88);
      box-shadow: 0 3px 8px rgba(22, 119, 255, 0.1);
      transform: none;

      span {
        color: #1677ff;
        font-weight: 700;
      }

      img {
        filter: drop-shadow(0 2px 3px rgba(22, 119, 255, 0.12));
        transform: scale(1.02);
      }
    }
    
    .ls {
      position: relative;
      text-align: center;
      box-sizing: border-box;
      border-radius: 10px;
      padding: 0.09rem 0.03rem 0.1rem;
      background: transparent;
      border: 1px solid transparent;
      transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
      width: 100% !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 0.96rem;
      margin-bottom: 0.03rem;
      overflow: hidden;
      
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        left: 0.12rem;
        right: 0.12rem;
        bottom: 0;
        height: 1px;
        background: rgba(232, 238, 246, 0.95);
        pointer-events: none;
      }
      
      img {
        width: 36px;
        height: 36px;
        object-fit: contain;
        display: block;
        margin: 0 auto 0.02rem;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: transparent;
        transition: transform 0.18s ease, filter 0.18s ease;
      }
      span {
        font-size: 10px;
        display: block;
        color: #5f6b7a;
        font-weight: 500;
        line-height: 1.05;
        white-space: normal;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100%;
      }

      &:not(.active):active {
        transform: translateY(1px);
      }

      &:not(.active):hover {
        background: rgba(245, 249, 255, 0.9);
      }
    }
  }

  /* 1. 恢复右侧内容区域的间距，解决遮挡问题 */
  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 1.3rem; /* 恢复原来的 1.3rem */
  }

  .rigts {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: .1rem;
    align-content: start;
    position: relative;
    padding: 0px 5px 70px;
    
    .game-item {
      position: relative;
      margin-top: 10px;
      text-align: center;
      cursor: pointer;
      
      .game-icon-container {
        position: relative;
        display: inline-block;
        img {
          width: 48%;
          border-radius: 20px;
          display: block;
          margin: 0 auto;
        }
        .api-icon {
          position: absolute;
          top: 0;
          right: 2%;
          width: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          img {
            width: 30px;
            object-fit: contain;
            border-radius: 0 15px 0 0;
          }
        }
      }
      .game-name {
        position: absolute;
        bottom: 5px;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        padding: 2px 0;
        border-radius: 0 0 20px 20px;
        width: 48%;
        margin: 0 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    &.hot-grid {
      .game-item {
        margin-top: 1px;
        .game-icon-container img {
          width: 98% !important;
          object-fit: cover !important;
          flex-shrink: 0 !important;
          box-sizing: border-box !important;
        }
        .game-name { width: 98% !important; }
      }
    }
    
    &.single-column {
      grid-template-columns: 1fr;
      .game-item {
        .game-icon-container img { width: 98% !important; margin-top: 10px; }
        .game-name { width: 98% !important; }
      }
    }
    
    &.three-column {
      position: relative;
      grid-template-columns: repeat(3, 1fr);
      padding: 40px 5px 70px;
      .game-item {
        margin-top: 0;
        .game-icon-container img {
          width: 98%!important;
          object-fit: cover!important;
          flex-shrink: 0!important;
          box-sizing: border-box!important;
        }
        .game-name {
          width: 100% !important;
          bottom: 0;
          border-radius: 0 0 8px 8px;
        }
      }
    }
    
    .game-item.full-width {
      .game-icon-container img { width: 98% !important; }
      .game-name { width: 98% !important; }
    }
  }
}

/* 2. 恢复顶部 Tab 栏的间距 */
.top-tab-bar {
  width: calc(100% - 1.3rem); /* 恢复原来的 1.3rem */
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000000; 
  padding: 5px;
  margin: 5px 0 0 1.3rem; /* 恢复原来的 1.3rem */
  z-index: 999;
  
  .game-type-tabs {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    flex: 1;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
    
    .game-type-tab {
      padding: 5px 20px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      background-image: url(/static/style/ddh.png);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      color: #333333; 
      border: none;
      outline: none;
      transition: all 0.2s ease;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &.active {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAA5CAMAAAAr+cg9AAAAYFBMVEUAAABjt/1ks/xltvpmtv9muf1mt/4LZ+ZhtPw7kfBmt/xitPsDX+FHnPQPaeQNaOQQaeQdd+jR5P/Z6f/G3f/p8v/w9v/g7P/L4P/k7/8CXeFbl+z1+f9xpfAzfeeRuvXavtWnAAAAEnRSTlMAMxBGHltqJBaXJk/lfavGfWGnzvn6AAAEK0lEQVRYw82Yi3qiMBCFF1DLCoKLyGUo+P5vuTMc4gGqlN0udU/CTGYysf+XxNb647/X2xb6Q4RzEss2SpPzSpjwnIqq65p/r64TVfzrbQVFrAy3/L1430b5zViST0iMoq2LonhXkAJ9cEigPcswixHbYPogazvdk6XNSJWiLFbpvfiCsnZpS95i6bLie5Tplrw9xWjvdVc65uj1sTbXx1la6tqbRmLvGcYVKvBoZ4K5wRcFvA1Y1of9DKxDmkRY1XJH5hhfEFFW6xGInxLj29RI6s/fsNJdr7U2qJ42yzDdi2mXqh8vdY7LuKqT8wTE11PJa+g6OPN9NdwgBpyGn9c4ixdgOUDgqtnJ+Im09QOVHC7OjYMVS1jdSuKPMDyRsqy1meXIOlQjYqYPucAMJzkBw1ekQb+IeP54O27lc9ULc18tb0c3xA9jycrygq7NLHSBYcwhZXk6PIwuzs9KYTK9Ib7j+CXN5aF09TqVf13SyC/HEeqxWOHHZtmV7fOCx9mbJCFA/F0sVc+WXb5flcQ7cIQ76TRBigwdCXo0N+8S7FNZigVcx7WDRI4hOCLp7qVcy0VMPIBknmtZMEVgHXrfOglCvz8WvabZi6QgelF3jqNFDkb79OHkPFjIcWHf6c2Na1s5DxzngaMaDB84Ts6DpVxFzxdGZvDkCO16HHuOCs3VM5wNGKxvS2uM4wgOux+cAa05Ng77KXXjKib6IHsKW83T1vV+DByRNNXr1N05ApGqyvNKDTsfncldGgGMy7PDYciEG1o0BOOwE2/g8GLJXyeJ7xyJ3PJX6SYpOPydd5Imf5UaOXtHHxyRvO5gRAJvB45jkEibv0atpI5DL8hJpOrFNwuHuOSco2EpY2eZYOH4zYiWiRyCIz6AKEeUSvvhV18Fixh5s24OI0RulXvQxm682tww0O2I+muKCxIcRPLFPyPV00mKvE9mPii37cCx4GCiRLqMnxz45xKheuY4AT+esCq3hAV9hiEXdpLYdiiHKdQN2cfSLn3IzS6rxLI1aiXeBzgWHIxuyAkg5XOU6Xi5qFyJcYqCox0LNyQ6ibTlsi4cfr2ybkVO3A53Q4K9geD/x2mbDNXOMoycMY0XjqpHiTvG+B9c25C9Hk2Xj79A4JcN484MEsi4HMeIaLWzpOr0UPYR3ixU6EDkdv0G6dVwGJPtsJMxkEMi0t2yQjV8q4WhizHgnD00Vw5Zy+Td2ZFIcjAMnAp1BzmlWtMoylbKbo2IpKcnGA7ESGJRdc0W6sSUKMUDDO4ISA4/FWUrxenPAyhwN0jCHdnZlhiJ6vRzC50Opn1km2EYjwQQL8CebCTsReAtYYxIFGUjRUsUZDESQ1mpiH6lPIUwimUMkCjK0dtGR4UgxacoyvKvdYQLCfEZiT1QaB0NAfpCo6NBc8JPWIvy3foNJmnskhJAWk4AAAAASUVORK5CYII=);
        color: #ffffff; 
        font-weight: bold;
      }
    }
  }
  
  .search-icon {
    display: flex;
    align-items: center;
    .search-img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: #1a1a1a;
      border: 0.04415rem solid #444;
      border-right: none;
      transition-duration: .15s;
      padding-left: 0.14493rem;
      padding-right: 0.28986rem;
      border-radius: 15px 0 0 15px;
      transform: translateY(-1px);
    }
  }
  
  .search-box {
    position: absolute;
    left: 1.3rem;
    right: 0;
    padding: 3px;
    display: flex;
    background: #1a1a1a; 
    border-radius: 15px 0 0 15px;
    
    .search-input-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      .search-img-inside {
        position: absolute;
        left: 10px;
        width: 16px;
        height: 16px;
        z-index: 1;
      }
      .search-input-with-icon {
        flex: 1;
        padding: 4px 4px 4px 32px;
        border-radius: 20px;
        font-size: 14px;
        background: #333333; 
        color: #ffffff; 
        border: 0.02415rem solid #555555;
        border-right: none;
        &::placeholder { color: #999999; }
      }
    }
    
    .search-close {
      margin-left: -30px;
      cursor: pointer;
      font-size: 24px;
      color: #999;
    }
  }
}

/* 强制隐藏编译后因路径丢失而变成“口”的字体图标 */
.riggs .lisImg .icon-text::before,
.riggs .lisImg .icon-text::after,
.riggs .lisImg::before,
.riggs .lisImg::after {
  display: none !important;
  content: none !important;
}

.realbet-content,
.sport-content {
  box-sizing: border-box !important;
  display: grid !important;
  gap: 0.1rem !important;
  align-content: start !important;
  position: relative !important;
  padding: 0 5px 70px !important;
  grid-template-columns: 1fr !important;
}

.realbet-icon-container,
.sport-icon-container {
  width: 100% !important;
  height: 120px !important;
  min-width: 100% !important;
  max-width: 100% !important;
  min-height: 120px !important;
  max-height: 120px !important;
  overflow: hidden !important;
  border-radius: 8px !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 22px !important;
    display: block !important;
    padding: 8px !important;
    box-sizing: border-box !important;
  }
}

.login-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .login-modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .login-modal-content {
    position: relative;
    z-index: 1001;
    width: 90%;
    max-width: 400px;
    background: #1a1a1a; 
    border-radius: 12px;
    overflow: visible;
  }
}

.app-download-bar-v2 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1a1a1a; 
  
  .flex-center {
    display: flex;
    align-items: center;
    flex: 1;
    width: 80%;
    height: 1rem;
  }
  
  .close-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.0rem;
    height: 0.5rem;
    font-size: 0.76rem;
    color: #ffffff; 
    cursor: pointer;
    margin-right: 0.1rem;
  }
  
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    .fit-image {
      width: 0.8rem;
      height: 0.7rem;
      object-fit: contain;
    }
  }
  
  .medium-text { font-size: 0.38rem; }
  .text { margin-left: 0.2rem; color: #ffffff; }
  
  .download-btn {
    padding: 0.1rem 0.6rem;
    color: #3d72fa;
    font-size: 0.35rem;
    border-radius: 0.1rem;
    cursor: pointer;
  }
}

/* ==================== 首页深蓝主题 ==================== */
.home-platform-page {
  min-height: 100vh;
  padding-bottom: 70px;
  background:
    radial-gradient(circle at 50% 118%, #1a6de0 0%, rgba(10, 58, 160, 0) 42%),
    linear-gradient(180deg, #03133c 0%, #062768 46%, #0a3f9c 100%);
  color: #f4f8ff;
  box-sizing: border-box;
}

.home-platform-page .xiding {
  background: transparent;
  border-bottom: 0;
  box-shadow: none;
}

.home-platform-page .banner-wrapper {
  padding: 6px 8px;
  background: transparent;
}

.home-platform-page .my-swipe {
  border: 1px solid rgba(150, 196, 255, 0.28);
  border-radius: 12px;
  background: rgba(4, 22, 70, 0.35);
  box-shadow: 0 8px 20px rgba(2, 12, 40, 0.28);
}

.home-platform-page .caosuo {
  width: calc(100% - 16px);
  position: relative;
  z-index: 3;
  min-height: 1.72rem;
  padding: 8px 7px;
  gap: 8px;
  border: 1px solid rgba(150, 196, 255, 0.22);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(8, 28, 88, 0.78) 0%, rgba(6, 22, 68, 0.86) 100%);
  color: #f4f8ff;
  box-sizing: border-box;
  box-shadow: 0 8px 18px rgba(2, 12, 40, 0.22);
}

.home-platform-page .caosuo .lefsg {
  position: relative;
  z-index: 1;
  flex: 0 0 38%;
  min-width: 0;
}

.home-platform-page .caosuo .home-user-entry {
  align-self: stretch;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.home-platform-page .home-user-summary {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 7px;
}

.home-platform-page .home-user-avatar {
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border: 2px solid rgba(246, 223, 169, 0.9);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 10px rgba(2, 12, 40, 0.28);
  object-fit: cover;
  box-sizing: border-box;
}

.home-platform-page .home-user-details {
  flex: 1;
  min-width: 0;
}

.home-platform-page .home-user-name-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}

.home-platform-page .home-user-name {
  min-width: 0;
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-platform-page .home-user-balance {
  display: flex;
  align-items: center;
  margin-top: 4px;
  color: #ffffff;
  line-height: 1;
}

.home-platform-page .home-user-currency {
  margin-right: 1px;
  color: #ffe59b;
  font-size: 13px;
  font-weight: 800;
}

.home-platform-page .home-user-balance strong {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.home-platform-page .home-balance-refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 3px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;
}

.home-platform-page .home-balance-refresh img {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}

.home-platform-page .home-user-arrow {
  flex: 0 0 auto;
  margin-left: 1px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 22px;
  font-weight: 300;
  line-height: 1;
}

.home-platform-page .caosuo .lefsg .meys {
  margin-top: 0;
}

.home-platform-page .caosuo > .balance-wrapper {
  flex: 0 0 auto;
  margin: 0;
}

.home-platform-page .caosuo .login-wrapper {
  gap: 7px;
}

.home-platform-page .caosuo .login-wrapper .button {
  min-width: 74px;
  height: 34px;
  padding: 0 12px;
  border-radius: 9px;
  font-size: 13px !important;
  line-height: 34px;
}

.home-platform-page .caosuo .lefsg .meys .lefs {
  color: #ffffff;
}

.home-platform-page .caosuo .lefsg .meys .lefs span {
  color: #ffe59b;
}

.home-platform-page .caosuo .lefsg .meys .lefs .imsg img {
  filter: brightness(0) invert(1);
}

.home-platform-page .caosuo .riggs {
  flex: 1 1 auto;
  min-width: 0;
  gap: 3px;
  align-items: center;
}

.home-platform-page .caosuo .riggs .lisImg {
  flex: 1 1 0;
  min-width: 0;
  max-width: none;
  color: #ffffff;
}

.home-platform-page .caosuo .riggs .lisImg .img-wrapper,
.home-platform-page .caosuo .riggs .lisImg > img,
.home-platform-page .caosuo .riggs .lisImg .link-icon {
  width: 34px;
  height: 34px;
  padding: 4px;
  border: 1px solid rgba(170, 210, 255, 0.28);
  border-radius: 11px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.06));
  box-shadow: 0 4px 10px rgba(2, 12, 40, 0.18);
  box-sizing: border-box;
}

.home-platform-page .caosuo .riggs .lisImg .img-wrapper img,
.home-platform-page .caosuo .riggs .lisImg .link-icon img {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  box-sizing: border-box;
}

.home-platform-page .caosuo .riggs .lisImg .icon-text,
.home-platform-page .caosuo .riggs .lisImg .icon-text[style] {
  color: #ffffff !important;
  font-weight: 600;
  font-size: 10px;
  white-space: nowrap;
}

.home-platform-page .balance-wrapper {
  margin-top: 0;
}

.home-platform-page .login-wrapper .custom-reg-btn {
  border-color: rgba(170, 210, 255, 0.4);
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.home-platform-page .login-wrapper .custom-login-btn {
  background: linear-gradient(135deg, #f5d98e, #dca84f);
  color: #4c2a10;
  box-shadow: 0 4px 10px rgba(2, 12, 40, 0.24);
}

.home-platform-page .gameBoxs {
  min-height: 620px;
  background: transparent;
  color: #f4f8ff;
}

.home-platform-page .gameBoxs .lfst {
  padding: 0.08rem 0.05rem 0.1rem;
  border: 1px solid rgba(140, 190, 255, 0.18);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(5, 22, 72, 0.92) 0%, rgba(4, 16, 54, 0.96) 100%);
  box-shadow: 0 9px 22px rgba(2, 12, 40, 0.22);
}

.home-platform-page .gameBoxs .lfst .ls {
  min-height: 0.96rem;
  border-radius: 11px;
}

.home-platform-page .gameBoxs .lfst .ls:not(:last-child)::after {
  background: rgba(140, 190, 255, 0.16);
}

.home-platform-page .gameBoxs .lfst .ls span {
  color: #d7e6ff;
  font-weight: 600;
}

.home-platform-page .gameBoxs .lfst .ls.active {
  position: relative;
  border-color: #e3c27f;
  background: linear-gradient(145deg, #f9e8bd 0%, #e4b75e 100%);
  color: #6b3c17;
  box-shadow: 0 5px 12px rgba(179, 116, 49, 0.20);
}

.home-platform-page .gameBoxs .lfst .ls.active::before {
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #a85f25;
  content: '';
}

.home-platform-page .gameBoxs .lfst .ls.active span {
  color: #663913;
  font-weight: 800;
}

.home-platform-page .gameBoxs .lfst .ls.active img {
  filter: drop-shadow(0 2px 3px rgba(110, 61, 18, 0.18));
}

.home-platform-page .gameBoxs .rigts {
  gap: 8px;
  padding-right: 8px;
  padding-left: 6px;
}

.home-platform-page .gameBoxs .rigts .game-item {
  overflow: hidden;
  border: 1px solid rgba(180, 214, 255, 0.42);
  border-radius: 13px;
  background: rgba(6, 24, 78, 0.5);
  box-shadow: 0 5px 14px rgba(2, 12, 40, 0.22);
}

.home-platform-page .gameBoxs .rigts .game-item .game-icon-container {
  display: block;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
}

.home-platform-page .gameBoxs .rigts .game-item .game-icon-container > img {
  width: 100% !important;
  border-radius: 12px;
}

.home-platform-page .gameBoxs .rigts .game-item .game-name {
  bottom: 0;
  width: 100% !important;
  padding: 10px 4px 4px;
  border-radius: 0 0 12px 12px;
  background: linear-gradient(180deg, rgba(59, 32, 12, 0), rgba(59, 32, 12, 0.82));
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  box-sizing: border-box;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}

.home-platform-page .realbet-icon-container,
.home-platform-page .sport-icon-container {
  border: 1px solid rgba(180, 214, 255, 0.35);
  background: rgba(8, 30, 92, 0.55);
  box-shadow: 0 5px 14px rgba(2, 12, 40, 0.18);
}

.home-platform-page .top-tab-bar {
  position: relative;
  width: calc(100% - 16px);
  margin: 6px 8px 0;
  padding: 6px;
  border: 1px solid rgba(150, 196, 255, 0.22);
  border-radius: 13px;
  background: linear-gradient(180deg, rgba(8, 28, 88, 0.78) 0%, rgba(6, 22, 68, 0.86) 100%);
  box-shadow: 0 5px 14px rgba(2, 12, 40, 0.18);
  box-sizing: border-box;
}

.home-platform-page .top-tab-bar .game-type-tabs {
  gap: 6px;
  padding: 0 2px;
}

.home-platform-page .top-tab-bar .game-type-tabs .game-type-tab {
  padding: 6px 16px;
  border: 1px solid rgba(150, 196, 255, 0.22);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  background-image: none;
  color: #d7e6ff;
  font-size: 12px;
}

.home-platform-page .top-tab-bar .game-type-tabs .game-type-tab.active {
  border-color: #d7a44c;
  background: linear-gradient(135deg, #f7e2ad, #dca84f);
  background-image: none;
  color: #633713;
  box-shadow: 0 4px 10px rgba(171, 104, 40, 0.17);
}

.home-platform-page .top-tab-bar .search-icon .search-img {
  width: 32px;
  height: 32px;
  padding: 6px;
  border: 1px solid rgba(150, 196, 255, 0.28);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  filter: brightness(0) invert(1);
  transform: none;
  box-sizing: border-box;
}

.home-platform-page .top-tab-bar .search-box {
  left: 0;
  right: 0;
  padding: 5px;
  border-radius: 13px;
  background: #0a2a72;
}

.home-platform-page .top-tab-bar .search-box .search-input-wrapper .search-input-with-icon {
  border: 1px solid rgba(150, 196, 255, 0.28);
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.home-platform-page .top-tab-bar .search-box .search-input-wrapper .search-input-with-icon::placeholder {
  color: #9cb6e6;
}

.home-platform-page .lang-menu-content {
  background: #0a2a72;
  color: #ffffff;
}

.home-platform-page .lang-title,
.home-platform-page .lang-item {
  border-bottom-color: rgba(150, 196, 255, 0.18);
}

.home-platform-page .lang-item.active {
  color: #ffe59b;
}

.home-platform-page .lang-cancel {
  background: rgba(255, 255, 255, 0.08);
  color: #d7e6ff;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue